import { isChatChannel, isTextChannel } from "../channels/types";

import type { MomentFormMoment } from "../moment/types/moment-form-moment";
import type { FollowUpChannelWithData } from "./reducer/schema";
import type { FollowUpDetails, FollowUpDetailsWithConfig } from "./server/types";

export function isChatChannelWithData(
  channel: FollowUpChannelWithData,
): channel is Extract<FollowUpChannelWithData, { channel: "slack" | "teams" }> {
  return isChatChannel(channel.channel);
}

export function isEmailChannelWithData(
  channel: FollowUpChannelWithData,
): channel is Extract<FollowUpChannelWithData, { channel: "work_email" | "personal_email" }> {
  return channel.channel === "work_email" || channel.channel === "personal_email";
}

export function isSmsChannelWithData(
  channel: FollowUpChannelWithData,
): channel is Extract<FollowUpChannelWithData, { channel: "twilio" }> {
  return channel.channel === "twilio";
}

export function isFollowUpDetailsWithConfig(
  followUpDetails?: FollowUpDetails | null,
): followUpDetails is FollowUpDetailsWithConfig {
  return (
    followUpDetails !== null &&
    followUpDetails !== undefined &&
    followUpDetails.config !== null &&
    followUpDetails.config !== undefined
  );
}

export const canHaveFollowUp = (
  moment: Pick<
    MomentFormMoment,
    "channel" | "only_additional_recipients" | "target_channel" | "notify_channel"
  >,
): boolean =>
  !isTextChannel(moment.channel) &&
  !moment.only_additional_recipients &&
  !moment.target_channel &&
  !moment.notify_channel;
